import { BaseNotificationMessage, NotificationLink } from './base-notification-message';
import { NotificationDetail } from '../../types';

interface EOIPendingMessageProps {
  readonly notification: NotificationDetail;
}

export function EOIPendingMessage({ notification }: EOIPendingMessageProps) {
  const { metadata, entityId } = notification.relatedEntity;
  const actionUrl = entityId ? `/selling/offers/${entityId}` : undefined;

  return (
    <BaseNotificationMessage notification={notification}>
      New Expression of Interest for <NotificationLink to={actionUrl}>{metadata.opportunityTitle}</NotificationLink>
    </BaseNotificationMessage>
  );
}
